export enum ENUMVoucherTypes {
  LMV = "lmv",
}
